export enum AvatarSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  XXX_LARGE = 'xxx-large',
  XX_LARGE = 'xx-large',
  XX_SMALL = 'xx-small',
  X_LARGE = 'x-large',
  X_SMALL = 'x-small',
}
